export function startFromFilter() {
    return function (input, start) {
        if (input === undefined) {
            return input;
        } else {
            return input.slice(+start);
        }
    };
}
